import { render, staticRenderFns } from "./WeeklyReportView.vue?vue&type=template&id=a081ace8&"
import script from "./WeeklyReportView.vue?vue&type=script&lang=js&"
export * from "./WeeklyReportView.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyReportView.vue?vue&type=style&index=0&id=a081ace8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard})
